import React from 'react';
import { INSTAGRAM_HANDLE, INSTAGRAM_LINK, SUPPORT_EMAIL } from './Shared';
import { Bellflower, Blossom, Daisy } from './FloralDecor';
const legalLinks = [{
  label: 'Terms of Sale',
  href: '#'
}, {
  label: 'Refund Policy',
  href: '#refund-policy'
}, {
  label: 'Privacy Policy',
  href: '#'
}, {
  label: 'Cookie Policy',
  href: '#'
}, {
  label: 'Digital Delivery',
  href: '#faq'
}];
export function Footer() {
  return <footer className="rice-paper relative overflow-hidden border-t border-[#e3d9c6] py-12 text-stone-900" data-id="element-100" data-mp="3ugbrpazjbkkx">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-101" data-mp="387fbm8yvbf9">
        <Bellflower className="absolute -bottom-4 left-[3%] hidden h-40 w-20 md:block" petalClassName="text-violet-300/60" centerClassName="text-emerald-600/40" data-id="element-102" data-mp="3ldu3ir0bkhva" />
        <Daisy className="absolute right-[5%] top-8 h-14 w-14" petalClassName="text-amber-100" centerClassName="text-amber-400" data-id="element-103" data-mp="29xm0ypkw16jm" />
        <Blossom className="absolute bottom-6 right-[12%] hidden h-12 w-12 md:block" petalClassName="text-pink-300/70" centerClassName="text-amber-400" data-id="element-104" data-mp="3l8qwo57filrz" />
      </div>
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-105" data-mp="3v7zuxa9bumk5">
        <h2 className="text-2xl font-bold tracking-tight text-emerald-900 md:text-3xl" data-id="element-106" data-mp="3q83rpd8gez5n">LUMEN AKASHA™</h2>

        <div className="mt-6 flex flex-col items-center justify-center gap-3 text-sm md:flex-row md:gap-8" data-id="element-107" data-mp="828nw8tlg9aq">
          <p data-id="element-108" data-mp="32w27regl89q">
            <span className="text-stone-500" data-id="element-109" data-mp="335pv8c173c9">Support: </span>
            <a className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-110" data-mp="htd1p57j9o3z">
              {SUPPORT_EMAIL}
            </a>
          </p>
          <p data-id="element-111" data-mp="qu1jmb01s8m5">
            <span className="text-stone-500" data-id="element-112" data-mp="qrfba95c1p2v">Instagram: </span>
            <a className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" href={INSTAGRAM_LINK} target="_blank" rel="noreferrer" data-id="element-113" data-mp="msy45plwwelg">
              {INSTAGRAM_HANDLE}
            </a>
          </p>
        </div>

        <nav aria-label="Legal" className="mt-8" data-id="element-114" data-mp="13rpsuop6ah9d">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-stone-600 md:text-sm" data-id="element-115" data-mp="18jr1m0n4tpun">
            {legalLinks.map(link => <li key={link.label} data-id="element-116" data-mp="1clcma85wr8fe">
                <a className="transition-colors duration-150 ease-out hover:text-emerald-800" href={link.href} data-id="element-117" data-mp="1hkfgexkcnu8l">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 border-t border-[#e3d9c6] pt-6 text-xs text-stone-500" data-id="element-118" data-mp="1rj4vkikv30l5">
          © Lumen Akasha™ 2026. All rights reserved. Do not reproduce or redistribute without written permission.
        </p>
      </div>
    </footer>;
}